module.exports = __webpack_public_path__ + "img/Docs@1x.593c7ec5.svg";